export default {
  title: {
    base: 'Easy-to-use',
    keyword: 'web application',
    extra: 'for doctors.',
  },
  description: {
    prescribe: 'Issue private e-prescriptions in seconds.',
    delivery: 'Patients receive their medication to their home in hours.',
  },
};
